import "./svg/rebate-rounded.svg"

export default {
    name: "rebate-rounded",
    viewBox: "24 24",
}
